import { oz } from '@weft/utils';

export const TimeSlotSchema = oz.object({
  year: oz.number().int().min(0),
  month: oz.number().int().min(0).max(11),
  day: oz.number().int().min(1).max(31),
});

export type TimeSlot = oz.infer<typeof TimeSlotSchema>;